/* eslint-disable react/prop-types */

import React from "react";

import { Fade } from "react-awesome-reveal";

export default function Advantage({ data }) {
  const columns = data.filter((col) => col.length > 0);

  return (
    <div className="bg-slate-50 py-20">
      <div className="container mx-auto px-4">
        <Fade direction="up" triggerOnce>
          <p className="mb-2 text-center text-sm font-semibold uppercase tracking-widest text-gold-700">
            Trusted By
          </p>
          <h2 className="font-display text-center text-4xl text-maroon-900 sm:text-5xl">
            Our Valuable Customers
          </h2>
          <p className="mx-auto mb-12 mt-3 max-w-xl text-center text-lg font-light text-slate-500">
            Honored to serve these esteemed customers.
          </p>
        </Fade>

        <div className="flex flex-col items-center justify-center gap-6 sm:flex-row sm:items-stretch sm:gap-8">
          {columns.map((column, colIndex) => (
            <div key={colIndex} className="flex flex-col gap-6">
              {column.map((item, index) => (
                <Fade direction="up" delay={120 * index} triggerOnce key={index}>
                  <div className="flex items-center justify-center rounded-2xl border border-slate-100 bg-white p-4 shadow-sm transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
                    <img src={item.imageUrl} alt="" loading="lazy" className="w-72 max-w-full" />
                  </div>
                </Fade>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
